import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import ReactOnRails from 'react-on-rails';
import { ThemeProvider } from '@material-ui/core/styles';
import Routes from '../routes/Routes';
import theme from '../lib/muiTheme';
import { CookiesProvider } from 'react-cookie';
import apolloClient from 'appDir/lib/apollo/client';
import { ApolloProvider } from '@apollo/client';
import { RecoilRoot } from 'recoil';
import { CloudinaryContext } from 'cloudinary-react';

const ClientRouterApp = (props: any, railsContext: any) => {
  // const { store, history } = theStore(props, railsContext);
  const { store, history } = ReactOnRails.getStore('appStore');
  return (
    <Provider store={store}>
      <RecoilRoot>
        <ApolloProvider client={apolloClient}>
          <CloudinaryContext cloudName={railsContext.cloudinaryCloudName}>
            <ThemeProvider theme={theme}>
              <ToastContainer
                hideProgressBar
                closeButton={false}
                pauseOnHover={false}
                pauseOnFocusLoss={false}
                autoClose={3500}
              />
              <CookiesProvider>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <ConnectedRouter history={history}>
                    <Routes {...{ ...props, railsContext }} />
                  </ConnectedRouter>
                </MuiPickersUtilsProvider>
              </CookiesProvider>
            </ThemeProvider>
          </CloudinaryContext>
        </ApolloProvider>
      </RecoilRoot>
    </Provider>
  );
};

export default ClientRouterApp;
